import styled from '@emotion/styled';

import { breakpoints } from '~/styles';

export const DetailsBody = styled.div`
  // the same width as Courses page has
  max-width: 976px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 16px 36px;
`;

export const PageHeader = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
  ${breakpoints.minTablet} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const PageHeadingsGroup = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const cardAnimation = `
  transition: 0.1s ease-in-out;
  &:hover {
    transform: scale(1.05);
  }
`;
